import React, { useState, useEffect, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { CircularProgress } from '@mui/material';
import { UserContext } from './UserContext';
import { getDefaultRouteForRole } from 'src/routes/defaultRouteByRole';

export const isTokenExpired = (token) => {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; // in seconds
    return decodedToken.exp < currentTime;
};

export const refreshToken = async () => {
  try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        throw new Error('No refresh token found');
      } 
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/auth/refresh-tokens`, { refreshToken: refreshToken });
      localStorage.setItem("accessToken", data.access.token);
      localStorage.setItem("refreshToken", data.refresh.token); 
      return data.access.token;
  } catch (error) {
      console.error("Refresh token error", error);
      throw error;
  }
};

const renderLoader = () => (
  <div style={{height:"90vh", display:"flex", justifyContent:"center", alignItems:'center'}}>
    <CircularProgress/>
  </div>
);

const AuthRoute = ({ element, requiredRole, unauthorizedRedirect }) => {
  const [isAuth, setIsAuth] = useState(null);
  const location = useLocation();
  const { user } = useContext(UserContext);

    useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');

    if (!accessToken || !refreshToken) {
      setIsAuth(false);
      return;
    }

    setIsAuth(true);
  }, [location]);

    if (isAuth === null) {
    return renderLoader();
    };
  if (!isAuth) {
    return <Navigate to="/auth/login" replace />;
  }

  if (requiredRole) {
    if (!user?.role) {
      return renderLoader();
    }

    if (user.role !== requiredRole) {
      const redirectPath = unauthorizedRedirect || getDefaultRouteForRole(user.role);
      return <Navigate to={redirectPath} replace />;
    }
  }

  return element;
};

export default AuthRoute;
